module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      L. Jon Wertheim\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("L. Jon Wertheim is the executive editor of "), _c('I', [_vm._v("Sports Illustrated")]), _vm._v(". He is the author of seven highly praised books, including the "), _c('I', [_vm._v("New York Times")]), _vm._v(" bestseller "), _c('I', [_vm._v("Scorecasting")]), _vm._v(". He is a regular contributor to CNN and National Public Radio and is a commentator for the Tennis Channel.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Qe3Ym4/tc-custom/9780547347226.jpg?1718169686426",
      "alt": "This image is the cover for the book Blood In The Cage"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Blood In The Cage\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Based on unique access to the Ultimate Fighting Championship (UFC) and its rival organizations, "), _c('i', [_vm._v("Blood in the Cage")]), _vm._v(" peers through the chain-link Octagon into the frighteningly seductive world of mixed martial arts, which has exploded in popularity despite resistance. Wertheim focuses on Pat Miletich, who runs the most famous MMA training school in the world. Single-handedly Miletich has transformed a gritty town on the Mississippi into an unlikely hotbed for his sport. He has also transformed many an average Joe into a walking weapon of destruction.")]), _c('p', [_vm._v("Wertheim intertwines Miletich’s own life story, by turns tragic and triumphant, with the larger story of the unholy rise of the UFC, from its controversial, back alley roots to the fastest-growing sports enterprise in America. "), _c('i', [_vm._v("Blood in the Cage")]), _vm._v(" takes readers behind the scenes, right down to the mat, from a punch in the kidney to the ping of the cash register, as Wertheim brilliantly exposes the no-holds-barred reality of the blood sport for a new generation.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Houghton Mifflin Harcourt (www.hmhco.com)\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0